<template>
  <div>
    <el-row class="bottom20">
      <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
        <el-table-column prop="name">
          <template slot="header" slot-scope="scope">
            客户名称<br>
            <el-input size="mini" v-model="pageSearch.search.like_name" placeholder="客户名称"></el-input>
          </template>
          <template slot-scope="scope">
            <a href="javascript: void(0);" @click.self="toDetailTab(scope.row)">{{scope.row.name}}</a>
          </template>
        </el-table-column>

        <el-table-column prop="roomIdArray">
          <template slot="header" slot-scope="scope">
            所属数据中心<br>
            <div style="height: 40px;"></div>
          </template>
          <template slot-scope="scope">
            <div v-for="roomId in scope.row.roomIdArray" :key="roomId">
              <dictionary-text :factory-name="'room'" :params="{type: 'ALL'}" :value="roomId"></dictionary-text>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="serviceLevel">
          <template slot="header" slot-scope="scope">
            服务等级<br>
            <div style="height: 40px;"></div>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'SERVICELEVEL'" :value="scope.row.serviceLevel"></dictionary-text>
          </template>
        </el-table-column>

        <el-table-column prop="customerType">
          <template slot="header" slot-scope="scope">
            客户类型<br>
            <div style="height: 40px;"></div>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'CUSTOMERTYPE'" :value="scope.row.customerType"></dictionary-text>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="pageSearch.current"
              :page-sizes="[10, 25, 50, 100]"
              :page-size="pageSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Emitter from 'element-ui/src/mixins/emitter'
  import {AuthInfo} from '@/util/user/authInfo'
  import DictionarySelect from '@/components/common/DictionarySelect'
  import DictionaryText from '@/components/common/DictionaryText'
  import BillingServer from  '@/api/billing'

  import {dictionaryContainer} from '@/util/common/dictionary'

  import {
    COMPONENT_MAIN, COMPONENT_LIST, COMPONENT_DETAIL,
    TAB_LIST,
    TAB_DETAIL, OPERATION_DETAIL_SHOW, OPERATION_DETAIL_ADD, OPERATION_DETAIL_EDIT,
    FN_SET_OPERATION, FN_LIST_QUERY, FN_TO_DETAIL_SHOW
  } from "./customer.common"

  export default {
    name: COMPONENT_LIST,
    componentName: COMPONENT_LIST,
    mixins: [Emitter],
    components: {
      DictionarySelect,
      DictionaryText,
    },
    props: {
      search: {},
    },
    data() {
      return {
        key: 'id',
        currentRowData: null,
        visited: [],
        pageSearch: {
          current: 1,
          size: 10,
          search: {
            like_name: null,
            isAuthUserIds: true,
            currentUserId: AuthInfo.userId,
            isAuthRoomIds: false,
            authRoomIds: [],
          },
        },
        page: {
          total: 0,
          records: []
        },
      };
    },
    computed: {
    },
    watch: {
      'pageSearch.current': {
        deep: false,
        handler() {
          this.queryByPage();
        },
      },
      'pageSearch.size': {
        deep: false,
        handler() {
          this.reQueryByPage();
        },
      },
      'page': {
        deep: true,
        handler(value) {
          if (value.total > 0) {
            let record;
            let records = value.records;
            if (this.currentRowData != null && this.currentRowData[this.key] != null) {
              for (let i = 0, l = records.length; i < l; i++) {
                if (this.currentRowData[this.key] === records[i][this.key]) {
                  record = records[i];
                  break;
                }
              }
            }
            if (record == null) {
              record = records[0];
            }
            this.select(record);
          }
        },
      },
      'pageSearch.search': {
        deep: true,
        handler(value) {
          this.reQueryByPage();
          if (value != null) {
            this.dispatch(COMPONENT_MAIN, FN_LIST_QUERY);
          }
        }
      }
    },
    methods: {
      handleCurrentChange(current) {
        this.pageSearch.current = current;
      },
      handleSizeChange(size) {
        this.pageSearch.size = size;
      },
      reQueryByPage() {
        if (this.pageSearch.current === 1) {
          this.queryByPage();
        } else {
          this.pageSearch.current = 1;
        }
      },
      queryByPage: _.debounce(function() {
        dictionaryContainer.getDictionary('room', {type: 'AUTH_SITE'}).then(roomDictionary => {
          let authRoomIds;
          let roomIds = roomDictionary.getValues();
          if (roomIds == null || roomIds.length <= 0) {
            authRoomIds = [];
          } else {
            authRoomIds = roomIds;
          }
          let pageSearch = _.merge(this.pageSearch, {
            search: {
              authRoomIds: authRoomIds
            }
          });
          BillingServer.customer.page(pageSearch).then((res) => {
            if (String(res.data.code) === '200' || res.data.success) {
              this.page = {
                total: res.data.data.total,
                records: res.data.data.records,
              };
            }
          });
        });
      }) ,
      query() {
        this.queryByPage();
      },
      reQuery() {
        this.reQueryByPage();
      },
      select(data) {
        this.currentRowData = data;
      },
      getSelectedCellClassName({row}) {
        let cellClassName = '';
        if (this.currentRowData && this.currentRowData[this.key] === row[this.key]) {
          cellClassName += ' currentAccess ';
        }
        return cellClassName;
      },
      visit(data) {
        let id = data[this.key];
        if (this.visited.indexOf(id) === -1) {
          this.visited.push(id);
        }
      },
      getVisitedRowClassName({row}) {
        let rowClassName = '';
        if (this.visited.indexOf(row[this.key]) !== -1) {
          rowClassName += ' visited';
        }
        return rowClassName;
      },
      toDetailTab(data) {
        this.select(data);
        this.visit(data);
        this.dispatch(COMPONENT_MAIN, FN_TO_DETAIL_SHOW, data);
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
